import { useSession } from "next-auth/react";
import Image from "next/image";
export const ImagePost = ({ imagePost, smallImage = false }) => {
  if (Boolean(imagePost) && Boolean(imagePost.url) == false) return <></>;
  return (
    <div className="mt-14 print:mt-9 print:pb-4">
      {smallImage ? (
        <figure className="inline-block rounded-3xl bg-lightLightGray print:text-center">
          <Image
            src={imagePost.url}
            width={200}
            height={300}
            alt={imagePost?.alt || "immagine di copertina"}
            className="h-auto rounded-3xl object-cover mix-blend-multiply print:block"
            sizes="200px"
            quality="65"
            priority={true}
          />
        </figure>
      ) : (
        <figure className="rounded-3xl bg-lightLightGray print:w-full print:text-center">
          <Image
            src={imagePost.url}
            width={1200}
            height={790}
            alt={imagePost?.alt || "immagine di copertina"}
            className="rounded-3xl object-cover mix-blend-multiply print:block print:w-1/3"
            sizes="(min-width: 1300px) 1200px, 100vw"
            priority={true}
          />
        </figure>
      )}

      {imagePost?.caption && (
        <figcaption
          className="mt-3 text-center text-base font-medium"
          itemProp="caption"
        >
          {imagePost.caption}
        </figcaption>
      )}
    </div>
  );
};

export const VideoPost = ({ videoPost }) => {
  const url = /^\d+$/g.test(videoPost)
    ? `https://player.vimeo.com/video/${videoPost}`
    : `https://www.youtube.com/embed/${videoPost}`;
  return (
    <>
      <iframe
        className="aspect-video"
        src={url}
        width="100%"
        allow="autoplay; fullscreen; picture-in-picture"
      ></iframe>
    </>
  );
};

export const AudioMultimedia = ({
  audioMultimedia,
  categoryIsPodcast,
  imagePost,
}) => {
  const session = useSession();
  const isAuthenticated = session?.status === "authenticated";
  return (
    <div
      className={`mt-6 rounded-2xl bg-[#e5e6e7] p-4 print:hidden ${
        isAuthenticated ? "block" : "hidden"
      }`}
      data-placeholder_class_index="1"
    >
      <iframe
        data-placeholder-image="https://buddismoesocieta.org/site/wp-content/plugins/complianz-gdpr/assets/images/placeholders/soundcloud-minimal.jpg"
        data-category="marketing"
        data-service="soundcloud"
        data-cmplz-target="src"
        data-src-cmplz="{post.meta.audio}&amp;color=%233e8498&amp;inverse=false&amp;auto_play=false&amp;show_user=false&amp;show_reposts=false&amp;show_teaser=false"
        src={`${audioMultimedia}&amp;color=%233e8498&amp;inverse=false&amp;auto_play=false&amp;show_user=false&amp;show_reposts=false&amp;show_teaser=false`}
        width="100%"
        height="20"
        frameBorder="no"
        scrolling="no"
      ></iframe>
      <small>CLICCA SULLA FRECCIA E ASCOLTA L&apos;AUDIO</small>
    </div>
  );
};
const FeatPost = ({
  imagePost,
  videoPost,
  audioMultimedia,
  mainCateogry = [],
  subCategory = [],
  smallImage = false,
}) => {
  const categoryIsPodcast = Boolean(
    mainCateogry.find((el) => el.slug.includes("podcast")) ||
      subCategory.find((el) => el.slug.includes("podcast"))
  );

  if (Boolean(videoPost)) return <VideoPost videoPost={videoPost} />;
  if (Boolean(audioMultimedia))
    return (
      <>
        <AudioMultimedia
          audioMultimedia={audioMultimedia}
          categoryIsPodcast={categoryIsPodcast}
          imagePost={imagePost}
        />
        <ImagePost imagePost={imagePost} smallImage={smallImage} />
      </>
    );
  return <ImagePost imagePost={imagePost} smallImage={smallImage} />;
};

export default FeatPost;
